import { ReactNode, createContext, useContext } from 'react'

import {
  SocialMediaType,
  SocialMessage,
  socialMessages,
} from '@/modules/statistics/social/types.ts'

interface SocialMediaContextType extends SocialMessage {
  socialMediaType: SocialMediaType
}

export const SocialMediaContext = createContext<
  SocialMediaContextType | undefined
>(undefined)

export const SocialMediaTypeProvider = ({
  socialMediaType,
  children,
}: {
  socialMediaType: SocialMediaType
  children: ReactNode
}) => {
  return (
    <SocialMediaContext.Provider
      value={{ socialMediaType, ...socialMessages[socialMediaType] }}
    >
      {children}
    </SocialMediaContext.Provider>
  )
}

export function useSocialMediaType() {
  const context = useContext(SocialMediaContext)

  if (context === undefined) {
    throw new Error(
      'useSocialMediaContext must be used within a SocialMediaProvider',
    )
  }

  return context
}
